<template>
<keep-alive>
    <div class="accountrecorder" name="accountrecorder">
      <topNav :title="title"></topNav>
      <div class="searchbox">
        <div class="daterange">
          <div class="daterange_label">选择日期区间</div>
          <div class="daterange_value" @click="fnShowDatePicker">{{ startDate ? startDate + "~" + endDate : ''}}</div>
          <van-calendar
          v-model="showDatePicker"
          :default-date="defaultDateRange"
          :max-range="31"
          type="range"
          color="#4687f8"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="handleSelectDateRange" />
        </div>
      </div>
      <div class="sectionmonth">
        <div class="total_box" v-if="parkingRecorder.length">
            <div class="checkall_box" @click="checkAll()">
              <div :class="['icon icon_checkbox', {'icon_checked': isCheckedAll}]"></div>
              <span class="txt">全选</span>
            </div>
            <div :class="['cus_button', {'loading': loadingInvoice }]" @click.stop="applicationInvoice()">
              <van-loading v-if="loadingInvoice" size="12px" color="#337ff5" />
              <span>批量开票</span>
            </div>
        </div>
        <div class="no-record" v-show="!parkingRecorder.length && !isLoading">
          <img src="../../../static/images/pic_nopaymentlist.png" alt="">
          <p>暂无缴费记录</p>
        </div>
        <div :class="['sectionCount', item.paymentScenario == 'RECHARGE' ? 'tempparking' : 'recharge' ]" v-for="(item, index) in parkingRecorder" :key="index">

            <div class="recorder_info" @click="recorderdetail(item)">
              <div class="check_box" @click.stop="changeChecked(item)">
                <div :class="['icon icon_checkbox', {'icon_checked': item.isChecked, 'disabled': item.invoiceStatus == '1'}]"></div>
              </div>
              <div class="parkingname">
                <div class="parkings">
                  <span>{{item.merchant + ' (' + item.paymentScenarioName + ')' }}</span>
              </div>
              <div class="parkingprice">
                  <p class="parkingtime">订单号：<span>{{item.orderNum}}</span></p>
                  <p class="parkingdate">缴费时间：<span>{{item.createDate + " " + item.createTime}}</span></p>
              </div>
              </div>
              <div class="money">
                  <p class="money_cell"><span>{{item.payPrice}}</span>元</p>
                  <p class="cardno">已支付</p>
                  <p class="cardno">{{ item.invoiceStatus == '1' ? '已开票' : '待开票' }}</p>
              </div>
            </div>
        </div>
        <p v-if="!isLoading && noMoreData && parkingRecorder.length" class="nomore">已经到底啦</p>
        <p v-show="isLoading">
          <van-loading class="loadmore" type="spinner" />
        </p>
      </div>
    </div>
</keep-alive>



</template>
<script>
import topNav from "../topnav/topnav"
import {DETAIL as API} from "@/assets/api"
import { Loading, Calendar } from 'vant';
import dayjs from 'dayjs'

export default {
  name: 'paymentRecords',
  components:{
     topNav,
     [Calendar.name]: Calendar,
  },
  data() {
    return {
      title:"缴费记录",

      showDatePicker: false,
      maxDate: null,
      minDate: null,
      defaultDateRange: [],
      startDate: '',
      endDate: '',

      parkingRecorder:[],
      pageNum: 0,
      pageSize: 10,
      paymentScenarioList: [
        {label: '临停缴费', value: "TEMPPARKING"},
        {label: '临停缴费', value: "TEMPPARKING_AI"},
        {label: '套餐充值', value: "RECHARGE"},
      ],
      Timer: null,
      isLoading: false,
      noMoreData: false,
      
      isCheckedAll: false,
      loadingInvoice: false,
    }
  },
  created(){
      this.setOptionalDateRange()
      this.setDateRange()
      this.setDefDateRange()
      this.getPaymentRecords()
    window.addEventListener('scroll', this.handleScroll , true)
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods:{
    setOptionalDateRange(){
      this.minDate = new Date(dayjs().subtract('3', 'month').add('1', 'day').format())
      this.maxDate = new Date(dayjs().format())
    },
    fnShowDatePicker(){
      this.showDatePicker = true
      this.setDateRange()
    },
    setDateRange(date){
      this.startDate = date ? dayjs(date[0]).format('YYYY-MM-DD') : dayjs().subtract('1', 'month').add('1', 'day').format('YYYY-MM-DD')
      this.endDate = date ? dayjs(date[1]).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD')
    },
    setDefDateRange(){
      this.defaultDateRange = [new Date(this.startDate), new Date(this.endDate)]
    },
    handleSelectDateRange(date){
      this.showDatePicker = false
      this.setDateRange(date)
      this.resetParkingData()
      this.getPaymentRecords()
    },
    resetParkingData(){
      this.parkingRecorder = []
      this.pageNum = 0
      this.pageSize = 10
    },
    handleScroll(){
      clearTimeout(this.Timer)
      this.Timer = setTimeout(()=>{
        if(this.isLoading) return
        var doms = document.getElementsByClassName('sectionCount')
        if(!doms.length) return

        var domH = doms[0].offsetHeight
        var pageH =  document.body.scrollHeight
        var scrollH = document.documentElement.scrollTop+document.body.scrollTop
        var leftH = pageH - scrollH - document.body.clientHeight
        if(leftH < domH*3 && !this.noMoreData && !this.isLoading ){
          this.pageNum++
          this.getPaymentRecords()
        }
      }, 300)

    },
    recorderdetail:function(item){
      this.$router.push({
        name: 'informdetail',
        query: {
          "merchant": item.merchant,//商户名称
          "carNumber": item.carNumber,//车牌号
          'payAmount': item.payPrice,//支付金额
          'parkingName': item.parkingName,//停车场
          'totalTime': item.parkTotalTime,//停车总时长
          'payChannelName': item.payChannelName,//支付方式
          'carInDate': item.createDate + ' '+item.createTime,//创建时间
          'orderNo': item.orderNum,//订单号
          'outOrderNo': item.outOrderNo,//第三方订单号
          'payState': item.paymentStatus,//支付状态
          'invoiceEnable': item.invoiceStatus, //是否显示开具发票按钮
          'paymentScenario': item.paymentScenario, // 支付场景
        }
      })
    },
    getPaymentRecords(){
      if(!this.startDate || !this.endDate){
        this.Toast('请选择选择日期区间')
        return
      }
      var originalId=sessionStorage.getItem("originalId");
      // var originalId= 'o0b1TwWxOg7gmDXycxEUFXGO8MSI'
      if(!originalId) return //没有originalId没有缓存或者重定向
      var req = {
        originalId: originalId,
        start: this.pageNum*this.pageSize,
        length: this.pageSize,
        draw: 0,
        startDate: this.startDate,
        endDate: this.endDate,
      }
      
      this.isLoading = true
      this.$http({
          method: 'get',
          url: API.GET_ORDER,
          data: req,
          success: function(res){
            if(res.code == 500){
              this.Toast(res.msg)
              this.isLoading = false
              return
            }
            if(res.data){
              if(res.data.length){
                var temp = this.parkingRecorder
                var resArr = res.data.map(item=>{
                  item.isChecked = false
                  var _filterList = this.paymentScenarioList.filter(ele=> ele.value == item.paymentScenario)
                  item.paymentScenarioName = _filterList.length ? _filterList[0].label : ''
                  return item
                })
                this.parkingRecorder = temp.concat(resArr)
              }else{
                this.noMoreData = true
              }
            }
            this.isLoading = false
          }.bind(this),
          error: function(error){
            this.isLoading = false
          }
      })
    },
    applicationInvoice(){
      let batchArr = this.parkingRecorder.filter(i=>i.invoiceStatus == '0' && i.isChecked).map(j=>{
        return JSON.stringify({
          "merchant": j.merchant,//商户名称
          "carNumber": j.carNumber,//车牌号
          'payAmount': j.payPrice,//支付金额
          'parkingName': j.parkingName,//停车场
          'totalTime': j.parkTotalTime,//停车总时长
          'payChanel': j.payChannel,//支付方式
          'carInDate': j.createDate + ' '+j.createTime,//创建时间
          'orderNo': j.orderNum,//订单号
          'outOrderNo': j.outOrderNo,//第三方订单号
          'payState': j.paymentStatus,//支付状态
          'invoiceEnable': j.invoiceStatus, //是否显示开具发票按钮
          'paymentScenario': j.paymentScenario, // 支付场景
          appid: j.appid,
        })
      })
      if(!batchArr.length){
          this.Toast('请选择需要开票的数据')
          return
      }
      
      this.$router.push({
        name: 'invoice',
        query: { recordarray: batchArr.join('__') }
      })
    },
    changeChecked(item){
      if(item.invoiceStatus == '1') return
      let isChecked = !item.isChecked
      this.$set(item, 'isChecked', isChecked)
    },
    checkAll(){
      this.isCheckedAll = !this.isCheckedAll
      this.parkingRecorder = this.parkingRecorder.map(i=>{
        i.isChecked = i.invoiceStatus == '0' ? this.isCheckedAll : false
        return i
      })
    },
  },
}
</script>
<style lang="less" scoped>

  .icon_checkbox{
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    background: url('../../../static/images/icon_checkbox.png') center no-repeat;
    background-size: 100%;
    &.icon_checked{
      background: url('../../../static/images/icon_checkbox_checked.png') center no-repeat;
      background-size: 100%;
    }
    &.disabled{
      filter: grayscale(100%);
    }
  }
  .loadmore{
    margin: 0 auto;
  }
  .accountrecorder{
    min-height: 100vh;
    border-bottom:1px solid #fff;
    box-sizing: border-box;
    .no-record{
      img{
        width: 148px;
        height: 91px;
        margin-top: 60px;
      }
      p{
        font-size: 14px;
        color: #9a9a9a;
        line-height: 30px;
      }
    }
    
    .sectionCount{
      background: white;
      padding: 22px 0;
      margin-bottom: 5px;
      .recorder_info{
        width: 100%;
        display: flex;
        padding: 0 8px;
        box-sizing: border-box;
        align-items: center;
        .check_box{
          display: flex;
          align-items: center;
          padding: 0 6px 0 4px;
        }
        .parkingname{
          width: 68%;
          text-align: left;
        }
        .parkingtime,.parkingdate{
          color:#999999;
          font-size: 13px;
          padding-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .money{
        width: 30%;
        text-align: right;
        .cardno{
          display: inline-block;
          border: 1px solid #e1e2e4;
          border-radius: 5px;
          font-size: 13px;
          padding: 2px;
          margin-left: 3px;
          vertical-align: 2px;
          margin-bottom: 3px;
          &:first-child{
            margin-left: 0;
          }
        }
        span{
          font-size: 18px;
          padding-right: 3px;
          color: #4687f8;
          padding-top: 5px;
          display: inline-block;
        }
        .money_cell{
          font-size: 12px;
          margin-bottom: 10px;
          span{
            font-weight: bold;
          }
        }
      }
      &.tempparking{
        background-image: url("../../../static/images/bg_tempparking.png");
        background-repeat: no-repeat;
        background-position: left center;
        background-size: auto 100%;
        .money_cell span{
          color: #f26714;
        }
      }
      &.recharge{
        background-image: url("../../../static/images/bg_recharge.png");
        background-repeat: no-repeat;
        background-position: left center;
        background-size: auto 100%;
        .money_cell span{
          color: #4687f8;
        }
      }
    }
  }
  .searchbox{
    padding: 10px 0;
  }
  .daterange{
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    &_label{
      flex: none;
      box-sizing: border-box;
      width: 6.2em;
      margin-right: 12px;
      color: #646566;
      text-align: left;
      word-wrap: break-word;
    }
    &_value{
      position: relative;
      overflow: hidden;
      color: #969799;
      text-align: right;
      vertical-align: middle;
      word-wrap: break-word;
      flex: 1;
    }
  }
  
  .total_box{
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0 8px;
      background-color: #fff;
      box-sizing: border-box;
      margin-bottom: 10px;
      .checkall_box{
        display: flex;
        align-items: center;
        .txt{
          margin-left: 5px;
          font-size: 14px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
    .cus_button{
        background-color: #fff;
        float: right;
        border-radius: 12px;
        border: solid 1px #337ff5;
        font-size: 13px;
        color: #337ff5;
        padding: 5px 12px;
        display: flex;
        &.primary{
          border: solid 1px #07c160;
          color: #07c160;
        }
    }

    .nomore{
      font-size: 14px;
      color: #9a9a9a;
      line-height: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/my/paymentRecords.vue